const initLazyloadVideo = () => {
  const lazyVideoEls = document.querySelectorAll('[data-lazyload-video]');
  if (!lazyVideoEls) return;

  const lazyVideoObserver = new IntersectionObserver(async entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        const entryTarget = entry.target;
        for (const videoSource of entryTarget.querySelectorAll('source')) {
          if (videoSource.dataset.src) {
            videoSource.src = videoSource.dataset.src;
          }
        }
        entryTarget.load();
        if (entryTarget.hasAttribute('autoplay')) {
          try { 
            await entryTarget.play(); 
          } catch { 
            /* blocked by browser policy */
          }
        }
        lazyVideoObserver.unobserve(entry.target);
      }
    }
  });

  lazyVideoEls.forEach(lazyVideoEl => {
    lazyVideoObserver.observe(lazyVideoEl);
  });
};

export default initLazyloadVideo;
